export type Logo = {
    src: string;
    alt: string;
    width: number;
    height: number;
};

type LogoMeta = Omit<Logo, "src">;

/**
 * The black and white marquee variants share identical alt text and dimensions
 * for every publication and differ only in the image URL. Keeping them as one
 * list avoids duplicating the metadata (and drifting) across two arrays.
 */
type FeaturedLogo = LogoMeta & {
    black: string;
    white: string;
};

const featuredLogos: FeaturedLogo[] = [
    {
        alt: "Muscle and Fitness logo — Inner Balance BodyMatched featured",
        width: 144,
        height: 48,
        black: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787129587/new_design/muscle-fitness-b_vqlsff.webp",
        white: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787130168/new_design/muscle-fitness-w_rhxruv.webp",
    },
    {
        alt: "Womanly magazine logo — Inner Balance BodyMatched featured in Womanly",
        width: 196,
        height: 48,
        black: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787129587/new_design/womanly-b_qcbh8l.webp",
        white: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787130168/new_design/womanly-w_khyzbe.webp",
    },
    {
        alt: "iHeart Radio podcast logo — Inner Balance BodyMatched featured on iHeart",
        width: 154,
        height: 48,
        black: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787129587/new_design/iHeart-b_o9zlxz.webp",
        white: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787130169/new_design/iHeart-w_z5ix6s.webp",
    },
    {
        alt: "LA Weekly logo — Inner Balance BodyMatched featured in LA Weekly",
        width: 130,
        height: 33,
        black: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787129586/new_design/LA_Weekly-b_sk8yor.webp",
        white: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787130167/new_design/LA_Weekly-w_kgxeyt.webp",
    },
    {
        alt: "Apple News logo — Inner Balance BodyMatched featured on Apple News",
        width: 190,
        height: 33,
        black: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787129586/new_design/Apple_News-b_mbsqrb.webp",
        white: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787130166/new_design/Apple_News-w_pp1t7w.webp",
    },
    {
        alt: "USA Today logo — Inner Balance BodyMatched featured in USA Today",
        width: 124,
        height: 48,
        black: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787129585/new_design/usa-today-b_r7jdiy.webp",
        white: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787129610/new_design/usa-today-w_if8xu9.webp",
    },
    {
        alt: "Healthcare Business Today logo — Inner Balance BodyMatched featured in Healthcare Business Today",
        width: 179,
        height: 48,
        black: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787129585/new_design/healthcare-b_ppubyr.webp",
        white: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787130165/new_design/healthcare-w_aepfed.webp",
    },
    {
        alt: "Medium logo — Inner Balance BodyMatched featured in Medium",
        width: 218,
        height: 48,
        black: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787129584/new_design/Medium-b_pribvv.webp",
        white: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787130166/new_design/Medium-w_rwlzmp.webp",
    },
    {
        alt: "US Reporter logo — Inner Balance BodyMatched featured in US Reporter",
        width: 192,
        height: 48,
        black: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787129584/new_design/us-reporter-b_zjzbhz.webp",
        white: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787130165/new_design/us-reporter-w_tetgn6.webp",
    },
    {
        alt: "Podcast network logo — Inner Balance BodyMatched women's health podcast feature",
        width: 76,
        height: 76,
        black: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787129583/new_design/podcast-b_ksqhuk.webp",
        white: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787130164/new_design/podcast-w_tjebkm.webp",
    },
    {
        alt: "In Touch Weekly logo — Inner Balance BodyMatched featured",
        width: 196,
        height: 48,
        black: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787129583/new_design/in-touch-b_vog5at.webp",
        white: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787130166/new_design/in-touch-w_torp5w.webp",
    },
    {
        alt: "MOM Magazine logo — Inner Balance BodyMatched featured in MOM Magazine",
        width: 144,
        height: 48,
        black: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787129582/new_design/mom-b_xvw9ta.webp",
        white: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787129669/new_design/mom-w_luu9uq.webp",
    },
    {
        alt: "Galore logo — Inner Balance BodyMatched featured in Galore",
        width: 76,
        height: 76,
        black: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787129582/new_design/Galore-b_exuoai.webp",
        white: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787129610/new_design/Galore-w_wpe2sc.webp",
    },
    {
        alt: "Huffman logo — Inner Balance BodyMatched featured in Huffman",
        width: 260,
        height: 48,
        black: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787129582/new_design/huffman-b_i1316n.webp",
        white: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787130165/new_design/huffman-w_lgedqy.webp",
    },
    {
        alt: "Influencer logo — Inner Balance BodyMatched featured in Influencer",
        width: 144,
        height: 48,
        black: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787129582/new_design/influencer-b_k1pold.webp",
        white: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787129610/new_design/influencer-w_ciu038.webp",
    },
    {
        alt: "BUST magazine logo — Inner Balance BodyMatched featured in BUST",
        width: 162,
        height: 48,
        black: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787129582/new_design/bust-b_alzqxe.webp",
        white: "https://res.cloudinary.com/dirscuuhp/image/upload/v1787129609/new_design/bust-w_titqrl.webp",
    },
];

const toLogo = ({ black, white, ...meta }: FeaturedLogo, variant: "black" | "white"): Logo => ({
    ...meta,
    src: variant === "black" ? black : white,
});

export const logos: Logo[] = [
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1769085345/muscle-fitness.webp",
        alt: "Muscle and Fitness logo — Inner Balance BodyMatched featured",
        width: 144,
        height: 48,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1769085340/womanly.webp",
        alt: "Womanly magazine logo — Inner Balance BodyMatched featured in Womanly",
        width: 196,
        height: 48,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1769085330/iHeart.webp",
        alt: "iHeart Radio podcast logo — Inner Balance BodyMatched featured on iHeart",
        width: 154,
        height: 48,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1769085313/LA_Weekly.webp",
        alt: "LA Weekly logo — Inner Balance BodyMatched featured in LA Weekly",
        width: 130,
        height: 33,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1784645959/Apple_News_logo.svg_1_1_iblpbw.webp",
        alt: "Apple News logo — Inner Balance BodyMatched featured on Apple News",
        width: 190,
        height: 33,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1769085335/usa-today_424298cf82.webp",
        alt: "USA Today logo — Inner Balance BodyMatched featured in USA Today",
        width: 124,
        height: 48,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1784646030/ny-weekly-hq-2025_1_bi9als.webp",
        alt: "New York Weekly logo — Inner Balance BodyMatched featured in New York Weekly",
        width: 424,
        height: 48,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1784646081/image_1_2_l6dfcd.webp",
        alt: "Healthcare Business Today logo — Inner Balance BodyMatched featured in Healthcare Business Today",
        width: 179,
        height: 48,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1784646129/la-wire-with-tm_1_ledggc.webp",
        alt: "Los Angeles Wire logo — Inner Balance BodyMatched featured in Los Angeles Wire",
        width: 177,
        height: 48,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778072625/2_1_hgw0sm.webp",
        alt: "Podcast network logo — Inner Balance BodyMatched women's health podcast feature",
        width: 76,
        height: 76,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1769085325/in-touch.webp",
        alt: "In Touch Weekly logo — Inner Balance BodyMatched featured",
        width: 196,
        height: 48,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1784646197/cropped-Mom-Magazine-LOGO-with-website-_1_uysymv.webp",
        alt: "MOM Magazine logo — Inner Balance BodyMatched featured in MOM Magazine",
        width: 144,
        height: 48,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1784646253/Galore_logo_1_pxlhp5.webp",
        alt: "Galore logo — Inner Balance BodyMatched featured in Galore",
        width: 76,
        height: 76,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1784646667/HML1_1_yfumwd.webp",
        alt: "HuffPost logo — Inner Balance BodyMatched featured in HuffPost",
        width: 260,
        height: 48,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1784646714/image_1507_2_dsbuf3.webp",
        alt: "BUST magazine logo — Inner Balance BodyMatched featured in BUST",
        width: 162,
        height: 48,
    },
];

export const logosBlack: Logo[] = featuredLogos.map((logo) => toLogo(logo, "black"));

export const logosWhite: Logo[] = featuredLogos.map((logo) => toLogo(logo, "white"));

export const homePreviewLogos: Logo[] = [
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790591810/new_design/108-1080204_muscle-fitness-logo_1_wajzl0.webp",
        alt: "Muscle & Fitness",
        width: 119,
        height: 40,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790591810/new_design/womanly-magazine.1200x0_1_y7wzj0.webp",
        alt: "Womanly",
        width: 135,
        height: 33,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790591810/new_design/images_1_xefeie.webp",
        alt: "iHeartRadio",
        width: 118,
        height: 37,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790591809/new_design/LA_Weekly_logo.svg_1_f7d7co.webp",
        alt: "LA Weekly",
        width: 125,
        height: 32,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790591810/new_design/Apple_News_logo.svg_1_ubnmtk.webp",
        alt: "Apple News",
        width: 127,
        height: 32,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790591810/new_design/usa-today-logo_1_z5gg03.webp",
        alt: "USA Today",
        width: 105,
        height: 41,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790591810/new_design/ny-weekly-hq-2025_1_b0mb2f.webp",
        alt: "New York Weekly",
        width: 237,
        height: 27,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790591810/new_design/image_1_m1cbsl.webp",
        alt: "Healthcare Business Today",
        width: 150,
        height: 40,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790591810/new_design/Medium-Wordmark-Black_1_iib9z0.webp",
        alt: "Medium",
        width: 136,
        height: 30,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790591809/new_design/62e0b3f0b4bd5ed40a97612d_prestige-relations-1_1_1_fgwkfq.webp",
        alt: "US Reporter",
        width: 125,
        height: 31,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790591809/new_design/dave-asprey-logo_1_eaxoqk.webp",
        alt: "Dave Asprey",
        width: 110,
        height: 43,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790591809/new_design/Logo_on_white_1_w5rpds.webp",
        alt: "Digital Journal",
        width: 192,
        height: 34,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790591809/new_design/la-wire-with-tm_1_oaxyfo.webp",
        alt: "Los Angeles Wire",
        width: 125,
        height: 34,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790591809/new_design/2_1_u7lozd.webp",
        alt: "Gladden Longevity Podcast",
        width: 44,
        height: 44,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790591809/new_design/2_2_x3hjb7.webp",
        alt: "In Touch Weekly",
        width: 129,
        height: 32,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790591809/new_design/cropped-Mom-Magazine-LOGO-with-website-_1_h3cg4h.webp",
        alt: "MOM Magazine",
        width: 102,
        height: 34,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790591809/new_design/Galore_logo_1_xcchbg.webp",
        alt: "Galore",
        width: 50,
        height: 50,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790591809/new_design/HML1_j8vsvr.webp",
        alt: "HuffPost",
        width: 150,
        height: 28,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790591809/new_design/7-1_1_eiozum.webp",
        alt: "Influencer Daily",
        width: 99,
        height: 33,
    },
    {
        src: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790591809/new_design/image_1507_gbgd4b.webp",
        alt: "BUST",
        width: 122,
        height: 36,
    },
];
